let storeFunction = {
  positionNotProcessOt: [],
};

export default storeFunction;
